(function(window) {
  const moneyFormatText =
    document.querySelector('.algolia-config-money-format')?.textContent?.toLowerCase() || '';
  const usesAmountNoDecimals = moneyFormatText.includes('amount_no_decimals');
  const usesAmountWithCommaSeparator = moneyFormatText.includes('amount_with_comma_separator');

  window.AlgoliaHelpers = {
    mergeTranslations: function (options) {
      const algolia = window.algoliaShopify;
      const algoliaTranslationsMetafieldEl = document.querySelector('[data-algolia-custom-translation-keys]');
      let algoliaCustomTranslationKeys = {};

      if (algoliaTranslationsMetafieldEl) {
        try {
          algoliaCustomTranslationKeys = JSON.parse(
            algoliaTranslationsMetafieldEl?.getAttribute('data-algolia-custom-translation-keys')
          );

          algolia.translations = {
            ...algolia.translations,
            ...algoliaCustomTranslationKeys,
          };

          if (algoliaCustomTranslationKeys.clear) {
            options.translations = {
              clearButtonTitle: algoliaCustomTranslationKeys.clear,
            };
          }
        } catch (e) {
          console.warn('Algolia custom translations keys are not valid JSON');
        }
      }
    },
    addTranslation: function (key, value) {
      const algolia = window.algoliaShopify;
      algolia.translations[key] = value;
    },
    // Transpiled into JavaScript code from "product-title.liquid" to replicate custom title logic in InstantSearch templates
    getBasicNetTitleParts: function (title) {
      if (!title || typeof title !== 'string') return '';

      const productTitleSplit = title.split(' - ');
      const productTitleFirst = productTitleSplit[0];
      const productTitleLast = productTitleSplit[productTitleSplit.length - 1];

      let finalTitle = title;

      if (productTitleSplit.length > 4) {
        let firstPart = productTitleFirst;

        // Caso speciale: "E - ONE LED"
        if (productTitleFirst === 'E' && productTitleSplit[1] === 'ONE LED') {
          firstPart = `${productTitleFirst}-${productTitleSplit[1]}`;
        }

        finalTitle = firstPart;
      }

      return {
        title: finalTitle,
        color: productTitleLast,
      };
    },
    getOmnibusPrice : function (item) {
      const omnibusRaw = item?.meta?.omnibus?.bestPrice;
      let itemOmnibus;

      if (omnibusRaw && typeof omnibusRaw === 'string') {
        itemOmnibus = JSON.parse(omnibusRaw);
      } else {
        itemOmnibus = omnibusRaw;
      }

      return itemOmnibus;
    },
    isOnSale : function (item) {
      const itemOmnibus = this.getOmnibusPrice(item);
      const variantMinPrice = item.variants_min_price;
      const variantCompareAtPriceMin = item.variants_compare_at_price_min;
      let fullPriceProduct = variantCompareAtPriceMin;

      if(itemOmnibus?.amount < fullPriceProduct){
        fullPriceProduct = itemOmnibus?.amount;
      }

      if (variantMinPrice < fullPriceProduct) {
        return true;
      } else {
        return false;
      }
    },
    doesItemPriceVary: function (item) {
      return item.variants_min_price !== item.variants_max_price;
    },
    addPriceVariesLabel: function (price) {
      const label = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--aa-price-varies-label-content');
      return label.replace('{{ price }}', price);
    },
    wrapCurrency : function (formattedAmount) {
      return formattedAmount.replace(/([€$£¥₽₹])/g, '<span class="currency">$1</span>');
    },
    // Algolia does not support Shopify money format strings, so we post-process
    // based on the configured format read from the DOM.
    currencyFormattingAwarePrice: function (price) {
      if (usesAmountNoDecimals) {
        return price.replace(/([.,])00(?=\D*$)/, '');
      }
      if (usesAmountWithCommaSeparator) {
        return price.replace(/(\d)\.(\d{2})(?=\D*$)/, '$1,$2');
      }
      return price;
    },

    refreshAOS: function () {
      if (window.AOS) {
        requestAnimationFrame(() => {
          AOS.refreshHard();
        });
      }
    },

    scheduleAOSRefresh: function (timeout = 500) {
      setTimeout(() => {
        window.AlgoliaHelpers.refreshAOS();
      }, timeout);
    },

    onInstantSearch: function (event, callback) {
      const hitsContainer = document.querySelector('#algolia-shopify-instantsearch');
      if (!hitsContainer) return;

      const attach = (attempts = 0) => {
        const MAX_ATTEMPTS = 100;
        const is = algoliaShopify?.instantsearch?.search;

        if (is) {
          is.on(event, callback);
        } else if (attempts < MAX_ATTEMPTS) {
          requestAnimationFrame(() => attach(attempts + 1));
        } else {
          console.warn(
            `[Algolia] Could not attach listener for event "${event}": InstantSearch not available after max attempts`
          );
        }
      };

      attach();
    },

    getProductBrand: function (hit) {
      const label = hit.meta?.basic_integration?.label_pim;
      const map = {
        'Kappa': 'KAPPA',
        'Authentic': 'KAPPA AUTHENTIC',
        'Robe di Kappa': 'ROBE DI KAPPA',
      };
      return map[label] || (label ? label.toUpperCase() : 'KAPPA');
    },

  };
})(window);